import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";

import middlewarePipeline from "./middlewarePipeline";

import Main from "./middleware/Main";
import AboutUs from "./middleware/AboutUs";
import Contacts from "./middleware/Contacts";
import EcoTaxi from "./middleware/EcoTaxi";

import Fractions from "./middleware/people/Fractions";
import Affiche from "./middleware/people/Affiche";
import Interactive from "./middleware/people/Interactive";
import Excursions from "./middleware/people/Excursions";
import Loyalty from "./middleware/people/Loyalty";
import ZeroWaste from "./middleware/people/ZeroWaste";

import EcoEducation from "./middleware/companies/EcoEducation";
import Office from "./middleware/companies/Office";
import Branded from "./middleware/companies/Branded";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'MainApp',
        component: () => import('../MainApp.vue'),

        children: [
            {
                path: '/',
                name: 'MainPage',
                component: () => import('../component/pages/MainPage.vue'),
                meta: {
                    middleware: [
                        Main
                    ]
                }
            },
            {
                path: '/about-us',
                name: 'AboutUsPage',
                component: () => import('../component/pages/about_us/AboutUsPage.vue'),
                meta: {
                    middleware: [
                        AboutUs
                    ]
                }
            },
            {
                path: '/contacts',
                name: 'ContactPage',
                component: () => import('../component/pages/ContactsPage.vue'),
                meta: {
                    middleware: [
                        Contacts
                    ]
                }
            },
            {
                path: '/ecotaxi',
                name: 'EcoTaxiPage',
                component: () => import('../component/pages/EcoTaxiPage.vue'),
                meta: {
                    middleware: [
                        EcoTaxi
                    ]
                }
            },

            {
                path: '/people/fractions',
                name: 'FractionsPage',
                component: () => import('../component/pages/people/FractionsPage.vue'),
                meta: {
                    middleware: [
                        Fractions
                    ]
                }
            },
            {
                path: '/people/excursions',
                name: 'ExcursionsPage',
                component: () => import('../component/pages/people/ExcursionsPage.vue'),
                meta: {
                    middleware: [
                        Excursions
                    ]
                }
            },
            {
                path: '/people/interactive',
                name: 'InteractivePage',
                component: () => import('../component/pages/people/InteractivePage.vue'),
                meta: {
                    middleware: [
                        Interactive
                    ]
                }
            },
            {
                path: '/people/zero-waste',
                name: 'ZeroWastePage',
                component: () => import('../component/pages/people/ZeroWastePage.vue'),
                meta: {
                    middleware: [
                        ZeroWaste
                    ]
                }
            },
            {
                path: '/people/affiche',
                name: 'AffichePage',
                component: () => import('../component/pages/people/AffichePage.vue'),
                meta: {
                    middleware: [
                        Affiche
                    ]
                }
            },
            {
                path: '/people/loyalty',
                name: 'LoyaltyPage',
                component: () => import('../component/pages/people/LoyaltyPage.vue'),
                meta: {
                    middleware: [
                        Loyalty
                    ]
                }
            },

            {
                path: '/companies/eco-education',
                name: 'EcoEducation',
                component: () => import('../component/pages/companies/EcoEducationPage.vue'),
                meta: {
                    middleware: [
                        EcoEducation
                    ]
                }
            },
            {
                path: '/companies/office',
                name: 'Office',
                component: () => import('../component/pages/companies/OfficePage.vue'),
                meta: {
                    middleware: [
                        Office
                    ]
                }
            },
            {
                path: '/companies/branded',
                name: 'Branded',
                component: () => import('../component/pages/companies/BrandedPage.vue'),
                meta: {
                    middleware: [
                        Branded
                    ]
                }
            },
            {
                path: '/companies/rop',
                name: 'RopPage',
                component: () => import('../component/pages/companies/RopPage.vue')
            },
            {
                path: '/donate',
                name: 'DonatePage',
                component: () => import('../component/pages/DonatePage.vue'),
            },
            // Маршрут /donate/success удалён — успех теперь показывается модалкой внутри DonateWidget
            // Редирект для обратной совместимости (старые закладки, кэш)
            {
                path: '/donate/success',
                redirect: '/donate?payment=success',
            },
            {
                path: '/manager/applications',
                name: 'ApplicationsPage',
                component: () => import('../component/pages/ApplicationsPage.vue'),
                meta: { requiresAuth: true, requiresApplications: true }
            },
            {
                path: '/admin/loyalty',
                name: 'AdminLoyaltyPage',
                component: () => import('../component/pages/AdminLoyaltyPage.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                }
            },
            {
                path: '/cashier',
                name: 'CashierPage',
                component: () => import('../component/pages/CashierPage.vue'),
                meta: {
                    requiresAuth: true,
                    requiresStaff: true
                }
            },
            {
                path: '/recycling-drop',
                name: 'RecyclingDropRedeem',
                component: () => import('../component/pages/RecyclingDropRedeem.vue'),
            },
        ],
    },
    {
        // Планшетная страница рендерится без общей шапки/футера и виджетов,
        // чтобы экран в экоцентре полностью занимал QR-код. Поэтому она вне MainApp.
        path: '/tablet/recycling',
        name: 'RecyclingTabletPage',
        component: () => import('../component/pages/tablet/RecyclingTabletPage.vue'),
        meta: {
            requiresAuth: true,
            requiresTablet: true
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {
    // Проверка требований аутентификации и прав администратора
    if (to.meta.requiresAuth) {
        const isAuthenticated = store.getters['auth/isAuthenticated'];
        if (!isAuthenticated) {
            // Перенаправляем на главную — аутентификация не пройдена
            return next({ path: '/', replace: true });
        }

        // При открытии защищённой страницы по ссылке профиль ещё может загружаться.
        if (!store.getters['auth/getUser']) await store.dispatch('auth/getProfile');

        if (to.meta.requiresApplications && !store.getters['auth/canManageApplications']) {
            return next({ path: '/', replace: true });
        }
        
        if (to.meta.requiresAdmin) {
            const user = store.getters['auth/getUser'];
            if (!user || user.role !== 'ADMIN') {
                return next({ path: '/', replace: true });
            }
        }

        if (to.meta.requiresStaff) {
            const user = store.getters['auth/getUser'];
            if (!user || (user.role !== 'ADMIN' && user.role !== 'CASHIER')) {
                return next({ path: '/', replace: true });
            }
        }

        if (to.meta.requiresTablet) {
            const user = store.getters['auth/getUser'];
            if (!user || (user.role !== 'ADMIN' && user.role !== 'CASHIER' && user.role !== 'QR_TABLET')) {
                return next({ path: '/', replace: true });
            }
        }
    }

    // Если есть middleware, обрабатываем его
    if (to.meta.middleware && to.meta.middleware.length) {
        const context = {
            to,
            from,
            next,
            store,
        };

        return to.meta.middleware[0]({
            context,
            nextMiddleware: middlewarePipeline(context, to.meta.middleware, 1)
        });
    }
    
    // Если нет middleware, просто переходим
    return next();
});

export default router;
